// Oculta el widget de Survicate eliminando su iframe del DOM
export function hideSurvicateWidget() {
  if (typeof window !== "undefined" && window._sva && typeof window._sva.closeSurvey === "function") {
    window._sva.closeSurvey();
    console.log("[Survicate] closeSurvey() ejecutado para ocultar el widget.");
    return;
  }
  // Fallback: eliminar el iframe si la API no está disponible
  if (typeof document === "undefined") return;
  const iframes = document.getElementsByTagName("iframe");
  let removed = false;
  for (let i = 0; i < iframes.length; i++) {
    const iframe = iframes[i];
    if (iframe && iframe.src && iframe.src.indexOf("survicate.com") !== -1) {
      iframe.parentNode && iframe.parentNode.removeChild(iframe);
      removed = true;
    }
  }
  if (removed) {
    console.log("[Survicate] Widget ocultado (iframe removido)");
  }
}
const SURVICATE_SCRIPT_MATCH = "survey.survicate.com/workspaces/"

const hasSurvicateApi = () => {
  if (typeof window === "undefined") {
    return false
  }

  return !!(
    window._sva &&
    typeof window._sva.retarget === "function" &&
    typeof window._sva.setVisitorTraits === "function" &&
    typeof window._sva.invokeEvent === "function"
  )
}

const getSurvicateScriptTag = () => {
  if (typeof document === "undefined") {
    return null
  }

  const scripts = document.getElementsByTagName("script")
  for (let i = 0; i < scripts.length; i += 1) {
    const script = scripts[i]
    if (script && script.src && script.src.indexOf(SURVICATE_SCRIPT_MATCH) !== -1) {
      return script
    }
  }

  return null
}

export const waitForSurvicateReady = ({ timeoutMs = 6000, pollMs = 120 } = {}) =>
  new Promise((resolve) => {
    if (hasSurvicateApi()) {
      resolve(true)
      return
    }

    let finished = false

    const done = (ready) => {
      if (finished) {
        return
      }
      finished = true

      if (intervalId) {
        clearInterval(intervalId)
      }
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      resolve(ready)
    }

    const scriptTag = getSurvicateScriptTag()
    if (scriptTag && typeof scriptTag.addEventListener === "function") {
      scriptTag.addEventListener("load", () => {
        done(hasSurvicateApi())
      })
      scriptTag.addEventListener("error", () => {
        done(false)
      })
    }

    const intervalId = setInterval(() => {
      if (hasSurvicateApi()) {
        done(true)
      }
    }, pollMs)

    const timeoutId = setTimeout(() => {
      done(hasSurvicateApi())
    }, timeoutMs)
  })

export const initializeSurvicateVisitor = async (
  traits,
  eventName = "login-cle",
) => {
  const ready = await waitForSurvicateReady()
  if (!ready) {
    return false
  }

  try {
    window._sva.retarget()
    window._sva.setVisitorTraits(traits)
    window._sva.invokeEvent(eventName)
    return true
  } catch (error) {
    return false
  }
}